import React from 'react';
export function Mission() {
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <div className="text-center" data-id="element-194">
          <blockquote className="text-lg md:text-2xl text-white leading-relaxed italic mb-6 md:mb-8" data-id="element-195">
            „Stworzyliśmy ten system dla polskich nauczycieli WF i trenerów
            siatkówki, którzy ciężko pracują ale wciąż nie widzą efektów jakich
            chcą.
            <br data-id="element-196" />
            <br data-id="element-197" />
            Żadnej teorii. Żadnych drogich konsultantów. Tylko narzędzia które
            naprawdę działają — żebyś mógł prowadzić zajęcia siatkówki naprawdę
            profesjonalnie."
          </blockquote>
          <p className="text-gold-accent font-bold text-lg md:text-xl" data-id="element-198">
            — Zespół Siatkówka Gotowa
          </p>
        </div>
      </div>
    </section>;
}